import { useContext } from 'react';
import PropTypes from 'prop-types';
import Radio from 'components/ui-components/Radio';
import RadioContainer from 'components/ui-components/RadioContainer';
import { HookFormContext } from 'components/cef_form/hook-form/providers/HookFormProvider';
import { Controller } from 'react-hook-form';
import provideHookFormFieldErrors from 'utils/hook-form/provideHookFormErrors';

const HookFormRadioContainer = ({
  className,
  direction = 'vertical',
  variant,
  id,
  label,
  description,
  radioItems,
  rules,
  onChange,
}) => {
  const { control, errors, handleBlur } = useContext(HookFormContext);

  const handleChange = (field, fieldValue) => {
    field.onChange(fieldValue);

    // Run additional function if passed
    if (onChange) {
      onChange(field.name, fieldValue);
    }
  };

  return (
    <Controller
      name={id}
      control={control}
      rules={rules}
      render={({ field }) => (
        <RadioContainer
          className={className}
          direction={direction}
          variant={variant}
          legend={label}
          description={description}
          groupName={id}
          errors={
            Object.keys(errors).length
              ? provideHookFormFieldErrors(id, errors)
              : null
          }>
          {radioItems.map(
            ({ id: radioId, label: radioLabel, value: radioValue }) => (
              <Radio
                key={radioId}
                variant="basic"
                id={radioId}
                value={radioValue}
                label={radioLabel}
                defaultChecked={field.value === radioValue}
                onChange={() => handleChange(field, radioValue)}
                onBlur={handleBlur ? () => handleBlur(id) : undefined}
              />
            ),
          )}
        </RadioContainer>
      )}
    />
  );
};

HookFormRadioContainer.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf(['vertical', 'horizontal']),
  variant: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  radioItems: PropTypes.array.isRequired,
  rules: PropTypes.object,
  onChange: PropTypes.func,
};

export default HookFormRadioContainer;
